import { observer } from 'mobx-react';
import * as React from 'react';
import { Selector } from 'telia-front-react';
function SelectorField(props) {
    var _a;
    const { field, helpMessage, errorMessage, callback, inputType } = props;
    const options = field.choices.map((c, idx) => {
        return {
            name: `${field.id}-${c.text}`,
            label: c.text,
            value: c.value || '',
            id: `field-${field.id}-choice-${idx}`,
            onChange: (checked) => {
                c.isSelected = checked;
                callback(field);
            }
        };
    });
    field.selectedOption =
        inputType === 'radio' ? ((_a = field.choices.find((c) => c.isSelected)) === null || _a === void 0 ? void 0 : _a.value) || '' : field.choices.filter((c) => c.isSelected).map((f) => f.value);
    return (React.createElement(Selector, { inputType: inputType, label: field.label, value: field.selectedOption, onChange: (value) => {
            field.choices.map((choice) => {
                if (choice.value === value) {
                    choice.isSelected = !choice.isSelected;
                }
            });
            callback(field);
        }, id: `field-${field.id}`, helpMessage: helpMessage, errorMessage: errorMessage, items: options, required: field.isRequired, hideLabel: field.labelHidden }));
}
export default observer(SelectorField);
//# sourceMappingURL=Selector.js.map